// React
import React, { useEffect } from 'react';

import Image from 'next/legacy/image';
import { useForm } from 'react-hook-form';

// Utilities
import {
    useContext,
    useElseware,
    useLabels,
    useWizardSubmit,
    useFormat,
} from 'utilities/hooks';
import { useInitiativeDataStore } from 'utilities/store';

// Components
import WithAuth from 'components/withAuth';
import FadeIn from 'components/fadeIn';
import WithPermission from 'components/withPermission';
import TitlePreamble from 'components/_wizard/titlePreamble';

const CreateStartComponent = ({ pageProps }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { CONTEXTS } = useContext();
    const { label, wizardSection } = useLabels();
    const { ewCreate } = useElseware();
    const { removeHtml } = useFormat();

    // ///////////////////
    // FORMS
    // ///////////////////

    const mainForm = useForm();

    // ///////////////////
    // SUBMIT
    // ///////////////////

    useWizardSubmit({
        noContext: () => [
            mainForm,
            async formData => {
                try {
                    console.log({ initiativeData: utilities.initiative.get() });
                    // Extra wait for id
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    return;
                } catch (error) {
                    console.warn(error);
                }
            },
        ],
    });

    // ///////////////////
    // DATA
    // ///////////////////

    const content = wizardSection('CreateStart');

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        async function createInitiative() {
            // Create Initiative
            const data = await ewCreate('initiative/initiative', {
                Name: '___',
            });

            // Update store
            utilities.updateInitiative(data?.data);
        }
        if (!utilities.initiative.get().Id) {
            createInitiative();
        }
        return undefined;
    }, []);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <WithPermission context>
            <FadeIn force>
                <TitlePreamble
                    title={content.title}
                    preamble={removeHtml(content.byline)}
                    usePreload={false}
                />
                <div className="relative flex h-[300px] w-full">
                    {content.image && (
                        <Image
                            layout="fill"
                            objectFit="contain"
                            src={content.image}
                        />
                    )}
                </div>
                {content.requiredInformation?.length > 0 && (
                    <div className="flex flex-col mt-32 ">
                        <p className="mb-16 text-teal-100 t-body">
                            {label('SectionRecommendToHaveReady')}
                        </p>
                        <div className="px-16 py-24 bg-teal-10">
                            <ul className="pl-16 space-y-8">
                                {content.requiredInformation.map(item => (
                                    <li
                                        className="ml-8 list-disc t-body"
                                        key={item.name}>
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </FadeIn>
        </WithPermission>
    );
};

CreateStartComponent.propTypes = {};

CreateStartComponent.defaultProps = {};

CreateStartComponent.layout = 'wizard';
CreateStartComponent.layoutSettings = {
    hideAside: true,
    hideNavigation: true,
    hideHelp: true,
    hideBottomBack: true,
    bottomCtaLabel: 'ButtonGetStarted',
};

export default WithAuth(CreateStartComponent);
